import React, { Component } from 'react'
import { connect } from 'react-redux'
import { placeOrder } from '../../redux/actions/cartActions'
import { showMessageModal, showContactInfo, hideContactInfo } from '../../redux/actions/miscActions'
import { deliveryCost, deliveryDivider, deliveryRules} from "../../utils/DeliveryCost";
import { Popover } from 'antd'

export class OrderCost extends Component {

  handleOrderConfirm=(shoppingCart, orderTotalCost)=>{    
    const { cust } = this.props
    const { user } = this.props.user
    const orderDeliveryCost = deliveryCost[cust.regio][orderTotalCost > deliveryDivider[cust.regio] ? 0 : 1]    
    if(!cust.name && !cust.email && !cust.adress && !cust.houseNum && !cust.regio){
      const feedback = {
        type: 'warning',
        txt: 'Controleer uw contact gegevens'
      }
      this.props.showMessageModal(feedback)
    } else if (shoppingCart.length === 0){
      const feedback = {
        type: 'warning',
        txt: 'Uw winkelwagen is leeg'
      }
      this.props.showMessageModal(feedback)
    } else {
      const date = new Date()
      const miliSec = date.getMilliseconds()
      const month = date.getMonth() + 1
      const modifiedMonth = month.toString().length === 1 ? month.toString().padStart(2, '0') : month
      const dayOfTheMonth = date.getDate()
      const hours = date.getHours()
      const year = date.getFullYear().toString().slice(2)
      const orderNumber = `${dayOfTheMonth}${modifiedMonth}${year}-${shoppingCart.length}${cust.email.toString().slice(0,2)}${hours}${miliSec}`
      this.props.placeOrder(shoppingCart, orderTotalCost, cust, orderNumber, user, orderDeliveryCost)
    }
  }

  toggleContactInfo=()=>{
    const { isContactInfoVisible } = this.props.misc
    if(isContactInfoVisible){
      this.props.hideContactInfo()
    } else {

      this.props.showContactInfo()
    }
  }

  render() {
    const { cart } = this.props.cart
    const { products, pakketten } = this.props.products
    const { isContactInfoVisible } = this.props.misc
    const regio = this.props.regio;
    const allItems = [...products, ...pakketten]
    let cartArray = []
    for(const property in cart){
      if(property !== 'owner' && property !== 'store'){
        cartArray.push(cart[property])
      }
    }

    const cartItems = cartArray.map(x => {return(x)})
    let shoppingCart = []
    for(let i = 0; i < cartItems.length; i++){
      const cartItem = allItems.filter(x => x.id === cartItems[i].id)[0]
      if(cartItem === undefined){continue;}
      const itemQuantity = cartItems.filter(x => x.id === cartItem.id)[0].quantity
      const newCartItem = [{...cartItem, quantity: itemQuantity}]
      shoppingCart.push(...newCartItem)
    }
    var reducer = (accumulator, currentValue) => accumulator + currentValue; 
    let orderTotal = [0]

    const cats = ["groenten", "fruit", "sap", "aardvrucht", "specerijen"];
    
    shoppingCart.forEach(item => {
      const product = allItems.filter(x => x.id === item.id)[0]      
      orderTotal.push(item.quantity * (cats.includes(product.productCategorie.toString()) && product.productOnSale ? product.itemSalesPrice : product.itemPrice))
    })
    const orderTotalCost = orderTotal.reduce(reducer)

    const leverkosten = <ul className="leverkosten">
      <li>Paramaribo</li>
      <li>Gratis voor bestellingen boven SRD 300</li>
      <li>SRD 17,50 voor bestellingen onder SRD 300</li>

      <li>Wanica & Commewijne</li>
      <li>SRD 50 voor bestellingen boven SRD 500</li>
      <li>SRD 100 voor bestellingen onder SRD 500</li>

      <li>Para & Brokopondo</li>
      <li>SRD 100 voor bestellingen boven SRD 500</li>
      <li>SRD 150 voor bestellingen onder SRD 500</li>
    </ul>
    return (
      <div className="order-cost">
        <div><p>Aantal producten</p> <p>{shoppingCart.length}</p></div>  
        <div><p>Totaal artikelen</p> <p>{new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'SRD'}).format(`${(orderTotalCost)}`)}</p></div>  

        {regio === 'OO' || !regio ? <p className="pick-up-info">Levering momenteel alleen mogelijk in Paramaribo, Wanica, Commewijne, Para en Brokopondo.</p> : 
        <div>
          <p>Leveringskosten</p>
          <p>
            {regio === undefined ? new Intl.NumberFormat("nl-NL", {
              style: "currency",
              currency: "SRD",
            }).format(0) : regio === 'PBM' ?
            new Intl.NumberFormat("nl-NL", {
              style: "currency",
              currency: "SRD",
            }).format(`${deliveryCost[regio][orderTotalCost > deliveryDivider[regio] ? 0 : 1]}`) : 'worden in overleg bepaald'
          }
          </p>
        </div>}  

        <div><p>Totaal</p> <p>{ regio === 'PBM' ? new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'SRD'}).format(`${orderTotalCost + deliveryCost[regio][orderTotalCost > deliveryDivider[regio] ? 0 : 1]}`) : new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'SRD'}).format(`${orderTotalCost}`) }</p></div>   
<div className="checkout-button">
        <p>{ regio && regio !== 'OO'  ? deliveryRules[regio] : ''}</p>
<button 
className={`bestel-knop med-main-btn ${ orderTotalCost < 50 || regio === 'OO' ? 'disabled' : null}`}
onClick={()=> this.handleOrderConfirm(shoppingCart, orderTotalCost)}>Bestellen</button>

    <button onClick={this.toggleContactInfo} className="display-form">{isContactInfoVisible ? 'Contactgegevens verbergen' : 'Contactgegevens weergeven'}</button>
</div>
{orderTotalCost < 50 ? <p className="min-order-text">
  Minimaal bedrag per bestelling is SRD 50
</p> : null}
      </div>
    )
  }
}

const mapStateToProps=(state)=>({
  misc: state.misc
})

export default connect(mapStateToProps, { placeOrder, showMessageModal, showContactInfo, hideContactInfo })(OrderCost)
